import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Input } from '../../../common/Form/Input';
import { text } from '../../../../utils/text';
import { NavigationButtons } from '../../../common/NavigationButtons/NavigationButtons';
import { Card } from '../../../common/Card/Card';
import { scenarioSteps, trackScenario } from '../../../../tracking';
import { Action, RoutePath, Spareformål } from '../../../../utils/types';
import { yupResolver } from '@hookform/resolvers/yup';
import { useHistory, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { Form } from '../../../common/Form/Form';
import { Layout } from '../../../common/Layout/Layout';
import { useFormContext } from '../../../../context/FormContext';
import { InputGroupSimple } from '../../../common/Form/InputGroupSimple';
import sizing from '../../../../utils/sizing.module.less';
import { QuestionTitle } from '../../../common/Form/QuestionTitle';
import pensjonist from '../../../../../assets/images/pensjonist.svg';
import barnespar from '../../../../../assets/images/barnespar.svg';
import jenteskate from '../../../../../assets/images/jenteskate.svg';
import stack from '../../../../../assets/images/stack.svg';
import { GroupOptionIllustration } from '../../../common/InputOptionIllustration/Illustration';
import styles from './kontoopplysninger.module.less';
import { AdditionalInfoAlert } from '../../../common/InfoAlert/AdditionalInfoAlert';
import { isValidSsn } from '@gjensidige/gpf-js-utils/es6/validation/ssn';
import { getUtbetalingsdetaljer } from '../../../../utils/api';
export const KontoForm = () => {
    const [{ kontoopplysninger, customerData, raadgivningData }, dispatch] = useFormContext();
    const [isSubmitting, setSubmitting] = useState(false);
    const { state } = useLocation();
    const history = useHistory();
    const { handleSubmit, control, watch } = useForm({
        resolver: yupResolver(kontoopplysningerValidationSchema),
        defaultValues: kontoopplysninger,
        reValidateMode: 'onChange',
        mode: 'onBlur',
    });
    const spareformål = watch('spareformål');
    useEffect(() => {
        trackScenario(scenarioSteps.KONTOOPPLYSNINGER);
    }, []);
    const submit = (data) => {
        const relevantKontoopplysninger = data.spareformål === Spareformål.BARN_BARNEBARN ? data : Object.assign(Object.assign({}, data), { barnetsFnr: undefined });
        dispatch({
            type: Action.SUBMIT_KONTOOPPLYSNINGER,
            kontoopplysninger: relevantKontoopplysninger,
        });
        const prevSpareformål = kontoopplysninger.spareformål;
        const newSpareformål = data.spareformål;
        if (newSpareformål && newSpareformål !== prevSpareformål) {
            updateUtbetalingsdetaljerForSpareformål(newSpareformål);
            updateRaadgivningIfNeeded(prevSpareformål, newSpareformål);
        }
        (state === null || state === void 0 ? void 0 : state.isEdit) ? history.push(RoutePath.SUMMARY) : history.push(RoutePath.AMOUNT);
    };
    const updateRaadgivningIfNeeded = (prevSpareformål, newSpareformål) => {
        const clearRaadgivning = () => dispatch({
            type: Action.SUBMIT_RAADGIVNING_DATA,
            raadgivningData: { egnethet: { answers: [] }, fatca: raadgivningData === null || raadgivningData === void 0 ? void 0 : raadgivningData.fatca },
        });
        // Hopp mellom pensjon og andre spareformål krever nytt sett med spørsmål fra rådgivning-api
        if ([prevSpareformål, newSpareformål].includes(Spareformål.PENSJON)) {
            clearRaadgivning();
            history.push(RoutePath.AMOUNT);
        }
    };
    const updateUtbetalingsdetaljerForSpareformål = (spareformål) => {
        setSubmitting(true);
        getUtbetalingsdetaljer(spareformål).then((result) => {
            if (result.isOk()) {
                dispatch({
                    type: Action.UPDATE_UTBETALINGSDETALJER,
                    utbetalingsdetaljer: result.value,
                });
            }
            setSubmitting(false);
        });
    };
    return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no, subtitle: text.LAYOUT.START_SAVING.SUBTITLE.no },
        React.createElement(Card, { step: 1 },
            React.createElement(Form, { onSubmit: handleSubmit(submit) },
                React.createElement("div", null,
                    React.createElement(QuestionTitle, { size: 'h3' }, text.FORM.KONTO_FORM.SPAREFORMÅL.TITLE.no),
                    React.createElement(InputGroupSimple, { name: "spareform\u00E5l", id: "spareform\u00E5l", type: "radio", options: spareformålOptions, control: control, centered: false, dividers: true })),
                spareformål === Spareformål.BARN_BARNEBARN && (React.createElement("div", null,
                    React.createElement(Input, { name: 'kontonavn', id: 'kontonavn', labelText: text.FORM.KONTO_FORM.BARNETS_NAVN.no, inputWrapperClassName: sizing.mw300, control: control, className: styles.barnetsNavn }),
                    React.createElement(Input, { name: 'barnetsFnr', id: 'barnetsFnr', inputMode: 'numeric', helpText: text.FORM.KONTO_FORM.BARNETS_FNR.HELP_TEXT.no, labelText: text.FORM.KONTO_FORM.BARNETS_FNR.LABEL.no, inputWrapperClassName: sizing.mw160, control: control }))),
                spareformål !== Spareformål.BARN_BARNEBARN && (React.createElement("div", { className: styles.kontonavn },
                    React.createElement(QuestionTitle, null, text.FORM.KONTO_FORM.KONTONAVN.TITLE.no),
                    React.createElement(Input, { name: 'kontonavn', id: 'kontonavn', labelText: text.FORM.KONTO_FORM.KONTONAVN.LABEL_TEXT.no, inputWrapperClassName: sizing.mw300, placeholder: text.FORM.KONTO_FORM.KONTONAVN.DEFAULT_VALUE.no, control: control }))),
                React.createElement(AdditionalInfoAlert, { text: text.FORM.KONTO_FORM.OPPRETT_FLER_VARSEL.no }),
                React.createElement(NavigationButtons, { loading: isSubmitting, onPrevious: !customerData.ssn ? () => history.push(RoutePath.LOGIN) : undefined, nextText: text.NAV_BUTTONS.NEXT.no })))));
};
const kontoopplysningerValidationSchema = yup.object().shape({
    spareformål: yup.string().required(text.FORM.KONTO_FORM.SPAREFORMÅL.VALIDATION.REQUIRED.no),
    kontonavn: yup
        .string()
        .notRequired() // Default verdi settes i backend
        .test('isValid', text.FORM.KONTO_FORM.KONTONAVN.VALIDATION.INVALID.no, (value) => {
        if (!value)
            return true;
        const safeKontonummer = new RegExp(/^[\s'`?!.,&<:;()/$€\-\p{L}0-9]+$/u);
        return yup.string().min(1).max(30).matches(safeKontonummer).isValidSync(value);
    }),
    barnetsFnr: yup.string().when('spareformål', {
        is: (formål) => formål === Spareformål.BARN_BARNEBARN,
        then: yup
            .string()
            .required(text.FORM.KONTO_FORM.SSN.VALIDATION.REQUIRED.no)
            .test('isValidSsn', text.FORM.KONTO_FORM.SSN.VALIDATION.INVALID.no, (value) => isValidSsn(value)),
    }),
});
//eslint-disable-next-line
const spareformålOptions = [
    {
        value: Spareformål.PENSJON,
        label: text.FORM.KONTO_FORM.SPAREFORMÅL.OPTIONS.PENSJON.LABEL.no,
        description: (React.createElement("div", { className: styles.option },
            React.createElement("div", { className: styles.description }, text.FORM.KONTO_FORM.SPAREFORMÅL.OPTIONS.PENSJON.DESCRIPTION.no),
            React.createElement(GroupOptionIllustration, { src: pensjonist }))),
        className: styles.fullWidthOption,
    },
    {
        value: Spareformål.SPESIFIKT_MÅL,
        label: text.FORM.KONTO_FORM.SPAREFORMÅL.OPTIONS.SPESIFIKT_MÅL.LABEL.no,
        description: (React.createElement("div", { className: styles.option },
            React.createElement("div", { className: styles.description }, text.FORM.KONTO_FORM.SPAREFORMÅL.OPTIONS.SPESIFIKT_MÅL.DESCRIPTION.no),
            React.createElement(GroupOptionIllustration, { src: stack }))),
        className: styles.fullWidthOption,
    },
    {
        value: Spareformål.IKKE_SPESIFIKT_MÅL,
        label: text.FORM.KONTO_FORM.SPAREFORMÅL.OPTIONS.IKKE_SPESIFIKT_MÅL.LABEL.no,
        description: (React.createElement("div", { className: styles.option },
            React.createElement("div", { className: styles.description }, text.FORM.KONTO_FORM.SPAREFORMÅL.OPTIONS.IKKE_SPESIFIKT_MÅL.DESCRIPTION.no),
            React.createElement(GroupOptionIllustration, { src: jenteskate }))),
        className: styles.fullWidthOption,
    },
    {
        value: Spareformål.BARN_BARNEBARN,
        label: text.FORM.KONTO_FORM.SPAREFORMÅL.OPTIONS.BARN_BARNEBARN.LABEL.no,
        description: (React.createElement("div", { className: styles.option },
            React.createElement("div", { className: styles.description }, text.FORM.KONTO_FORM.SPAREFORMÅL.OPTIONS.BARN_BARNEBARN.DESCRIPTION.no),
            React.createElement(GroupOptionIllustration, { src: barnespar }))),
        className: styles.fullWidthOption,
    },
];
